import React from 'react'
import { designTokens } from '@/utils/design-tokens'

// 현재 호스트명 기준 환경 판별
// - localhost / 127.0.0.1 → 로컬
// - dev.dotc.ai          → 개발계
// - 그 외(운영 등)        → 표시 안 함
const getEnvInfo = (): { label: string; color: string } | null => {
  if (typeof window === 'undefined') return null
  const host = window.location.hostname

  if (host === 'localhost' || host === '127.0.0.1') {
    return { label: 'LOCAL', color: designTokens.colors.success.DEFAULT }
  }
  if (host === 'dev.dotc.ai') {
    return { label: 'DEV', color: designTokens.colors.warning.DEFAULT }
  }
  return null
}

/**
 * 우측 하단 코너 리본 — 로컬/개발계에서만 환경을 표시.
 * 클릭을 막지 않도록 pointer-events: none.
 */
const EnvRibbon: React.FC = () => {
  const env = getEnvInfo()
  if (!env) return null

  return (
    <div
      style={{
        position: 'fixed',
        bottom: 0,
        right: 0,
        width: 90,
        height: 90,
        overflow: 'hidden',
        pointerEvents: 'none',
        zIndex: 99999
      }}
    >
      <div
        style={{
          position: 'absolute',
          bottom: 20,
          right: -30,
          width: 130,
          transform: 'rotate(-45deg)',
          textAlign: 'center',
          backgroundColor: env.color,
          color: designTokens.colors.white,
          fontFamily: designTokens.typography.fontFamily.sans[0],
          fontSize: '10px',
          fontWeight: 700,
          letterSpacing: '0.5px',
          padding: '2px 0',
          boxShadow: '0 1px 3px rgba(0, 0, 0, 0.3)'
        }}
      >
        {env.label}
      </div>
    </div>
  )
}

export default EnvRibbon
